export default __webpack_public_path__ + "static/media/kitchen3-afterC-1440w.763d5cdd.webp";